import api from '@/api';

const state = {
    connString: '',
};

const mutations = {
    setconnString(state, connString) {
        state.connString = connString;
    },
};

const actions = {
    async fetchConnString({ commit }) {
        const response = await api.admin.serverData();
        // console.log(response.data.db.sF9527);
        commit('setconnString', response.data.db.sF9527);
    },
};

const getters = {
    connString() {
        return state.connString || '';
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/admin.js